var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 12,
    viewBox: "0 0 9 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.154 3.35304L0 4.50704V6.88604L1.154 8.04004C1.363 8.24904 1.702 8.24904 1.911 8.04004L3.876 6.07504C4.085 5.86604 4.085 5.52704 3.876 5.31804L1.911 3.35304C1.702 3.14404 1.363 3.14404 1.154 3.35304Z",
    fill: "#799088"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.35304 10.2381L4.50704 11.3921H6.88604L8.04004 10.2381C8.24904 10.0291 8.24904 9.69012 8.04004 9.48112L6.07504 7.51612C5.86604 7.30712 5.52704 7.30712 5.31804 7.51612L3.35304 9.48112C3.14404 9.69012 3.14404 10.0291 3.35304 10.2381Z",
    fill: "#799088"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.04004 1.154L6.88604 0H4.50704L3.35304 1.154C3.14404 1.363 3.14404 1.702 3.35304 1.911L5.31804 3.876C5.52704 4.085 5.86604 4.085 6.07504 3.876L8.04004 1.911C8.24904 1.702 8.24904 1.363 8.04004 1.154Z",
    fill: "#799088"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow_left.e0506d5afa4baa34e31c3e54d5cdd75c.svg";
export { ForwardRef as ReactComponent };